/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Cat_Baslangic_TitleInputs */

const tr_faq_cat_baslangic_title = /** @type {(inputs: Faq_Cat_Baslangic_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlangıç ve Kurulum`)
};

const en_faq_cat_baslangic_title = /** @type {(inputs: Faq_Cat_Baslangic_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getting Started`)
};

const de_faq_cat_baslangic_title = /** @type {(inputs: Faq_Cat_Baslangic_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erste Schritte`)
};

const ru_faq_cat_baslangic_title = /** @type {(inputs: Faq_Cat_Baslangic_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начало работы`)
};

/**
* | output |
* | --- |
* | "Getting Started" |
*
* @param {Faq_Cat_Baslangic_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_cat_baslangic_title = /** @type {((inputs?: Faq_Cat_Baslangic_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Cat_Baslangic_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_cat_baslangic_title(inputs)
	if (locale === "de") return de_faq_cat_baslangic_title(inputs)
	if (locale === "ru") return ru_faq_cat_baslangic_title(inputs)
	return tr_faq_cat_baslangic_title(inputs)
});